import React, {
  useState,
  useEffect,
  useContext,
  createRef,
  useRef,
  CSSProperties,
} from "react";
import { createPortal } from "react-dom";

import { inject, observer } from "mobx-react";
import { ThemeContext } from "../../store/ThemeProvider";
import intl from "react-intl-universal";
import { alpha, getPendantColor } from "../../utils/color";
import { getComponentById, getPageSameType, isWeb, isIphoneX} from "../../utils/util";
import { IComponent, IComponentContainer } from "../../component.d";
import {
  ICommentSend,
  ICommentGift,
  ICommentEmotion,
} from "./AllForCommentSend";
import { style } from "../../utils/image";
import stat from "../../utils/stat";
import { setContainer } from "../../utils/dom";
import useRealBottomTab from "../ComponentNavigator/useRealBottomTab";
import RootStore from '../../store/RootStore';
import usePortalDom from "../hooks/usePortalDom";
import {PageContext} from "../ComponentNavigatorV2/PageContext";

let focusTimer = 0;

const formatPrice = (price: number) => {
  return price ? Number(Number(price) / 100).toFixed(2) : "0.00";
};

const EmotionList = (props: {
  onFetchEmotion: () => void;
  list?: ICommentEmotion[] | null;
}) => {
  const { h1Color, mainColor, componentColor } = useContext(ThemeContext);
  const [inited, setInited] = useState(false);
  const { list, onFetchEmotion } = props;

  useEffect(() => {
    if (!inited) {
      setInited(true);
      if(list == null) {
        onFetchEmotion();
      }
    }
  }, [inited]);

  return (
    <div
      className="comment-emotion"
      style={{
        background: alpha(componentColor, 1),
        borderColor: alpha(h1Color, 0.05),
      }}
    >
      <div className="list">
        {(list || []).map((it: ICommentEmotion) => {
          return (
            <div key={it.id} className="list-item-wrapper">
              <img
                className="item"
                src={style(it.images, "avatar_150")}
                onClick={() => {
                  let event = new Event("custom-comment-emotion-choose");
                  event.data = {
                    id: it.id,
                    name: it.name,
                    image: it.images,
                  };
                  window.dispatchEvent(event);
                }}
              />
              <p style={{ color: alpha(h1Color, 0.5) }}>{it.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const GiftModal = (props: {
  onFetchGift: () => PromiseLike<any>;
  list?: ICommentGift[];
}) => {
  const [show, setShow] = useState(false);
  const [count, setCount] = useState(1);
  const [choose, setChoose] = useState<ICommentGift | null>(null);
  const { h1Color, mainColor, componentColor } = useContext(ThemeContext);
  const [bgColor, foreColor] = getPendantColor(mainColor, true);
  const [inited, setInited] = useState(false);
  const [lastTime, setLastTime] = useState(0);
  const [nowTime, setNowTime] = useState(0);
  const [timer, setTimer] = useState(0 as any);
  const SEND_DOWNCOUNT = 30 * 1000;
  const { onFetchGift, list } = props;

  const getCountDown = () => {
    let between = lastTime - Date.now();
    return Math.floor(between / 1000);
  };

  const renderSendButton = () => {
    if (Date.now() >= lastTime) {
      clearInterval(timer);
      return (
        <a
          className="comment-submit"
          onClick={() => {
            setShow(false);

            if (choose && choose.id) {
              let event = new Event("custom-comment-gift-choose");
              event.data = {
                count: count,
                id: choose.id,
                name: choose.name,
                image: choose.image,
              };
              window.dispatchEvent(event);

              let localTime = Date.now() + SEND_DOWNCOUNT;
              setLastTime(localTime);
              // 还要在本地设置一下，否则刷新进来会不生效的
              window.localStorage.setItem("gift_lasttime", String(localTime));
              setNowTime(Date.now());
              let timer = setInterval(() => {
                setNowTime(Date.now());
              }, 1000);

              setTimer(timer);
            }
          }}
          style={{ background: mainColor, color: bgColor }}
        >
          {intl.get("Give")}
        </a>
      );
    } else {
      let text = `${getCountDown()}${intl.get("Second")}`;
      return (
        <a
          className="comment-submit"
          style={{ background: alpha(foreColor, 0.05), color: bgColor }}
        >
          {text}
        </a>
      );
    }
  };

  // 获取数据
  useEffect(() => {
    if (show && !inited) {
      onFetchGift();
      setInited(true);
    }
  }, [`${show}${inited}`]);

  useEffect(() => {
    let localTime = window.localStorage.getItem("gift_lasttime");
    if (localTime) {
      setLastTime(Number(localTime));
    }
  }, []);

  useEffect(() => {
    const onShowEvent = () => {
      setShow(true);
    };
    window.addEventListener("custom-comment-gift-show", onShowEvent);

    return () => {
      window.removeEventListener("custom-comment-gift-show", onShowEvent);
    };
  }, []);

  const wrapper = usePortalDom({
    parentElement:window.document.getElementById('root-modal')! as HTMLElement
  });

  return wrapper && createPortal(
    <div className={`modal-gift ${show ? "visible" : ""}`}>
      <div className="empty-fill"></div>
      <div className="modal-gift-content">
        <div className="header">
          {intl.get("Send Gift")}
          <img
            onClick={() => setShow(false)}
            className="close"
            src={require("../../assets/x-20.png")}
          />
        </div>
        <div className="list">
          {(list || []).map((it: ICommentGift) => {
            return (
              <div
                onClick={() => {
                  setChoose(it);
                }}
                className={`item ${
                  choose && choose.id == it.id ? "active" : ""
                }`}
                key={it.id}
                style={{
                  borderColor:
                    choose && choose.id == it.id ? mainColor : "#fff",
                }}
              >
                <img src={style(it.image, "avatar_150")} />
                <p className="name">{it.name}</p>
                <p className="price">￥{formatPrice(it.price)}</p>
              </div>
            );
          })}
        </div>
        <div className="footer">
          <div>
            <span className="unit">{intl.get("Unit")}</span>
            <div className="number-step">
              <a
                onClick={() => {
                  setCount(Math.max(1, count - 1));
                }}
              >
                -
              </a>
              <span>{count}</span>
              <a
                onClick={() => {
                  setCount(Math.min(10, count + 1));
                }}
              >
                +
              </a>
            </div>
          </div>
          {renderSendButton()}
        </div>
      </div>
    </div>,
    wrapper! as HTMLElement
  );
};

const FixedCommentSend = (props: {
  onChange: (e: string) => void;
  onSubmit: () => PromiseLike<any>;
  question: boolean;
  isQuestion: boolean;
  focus: boolean;
  commentText: string;
  replyId?: number;
  replyName?: string;
  onFocusChange: (e: boolean) => void;
  onQuestionChange: (e: boolean) => void;
  onFetchEmotion: () => void;
  emotionList?: ICommentEmotion[] | null;
  emotion: boolean;
  rootStore?:RootStore;
}) => {
  const {
    focus,
    isQuestion,
    replyId,
    question,
    onChange,
    onSubmit,
    commentText,
    onQuestionChange,
    onFocusChange,
    emotionList,
    emotion,
    onFetchEmotion,
    replyName,
  } = props;
  const { h1Color, mainColor, componentColor } = useContext(ThemeContext);

  const {pagedataStore} = props.rootStore!;

  const commentInput = createRef<HTMLTextAreaElement>();

  useEffect(() => {
    if (focus) {
      commentInput.current!.focus();
    }
  }, [focus]);

  const [bgColor, foreColor] = getPendantColor(mainColor, true);
  const [posting, setPosting] = useState(false);

  const commentSubmitEvent = posting
    ? (e: any) => {}
    : (e: any) => {
        setPosting(true);
        onSubmit().then(() => {
          setPosting(false);
          onFocusChange(false);

          let target = document.getElementById("commentInput0");
          if (target) {
            target.blur();
          }
        });
        e.preventDefault();
        // clearTimeout(focusTimer);
        // commentInput.current!.focus();
      };

  const renderMethod = pagedataStore.renderMode == 'pc' ? (child:any)=>{
    return child;
  } : (child:any, domContainer:HTMLElement)=>{
    return domContainer ? createPortal(child, domContainer) : null;
  };

  const pageContext = useContext(PageContext);
  const wrapper = usePortalDom({
    parentElement:window.document.getElementById(`page-bottom-${pageContext.cid}`)! as HTMLElement
  });

  return renderMethod(
    <div
      className="all-for-commentsend-mask"
      style={{ display: focus ? "flex" : "none" }}
    >
      <div
        className="mask-fill-empty"
        onClick={() => {
          // commentInput.current!.blur();
          onFocusChange(false);
        }}
      ></div>
      <div
        className="all-for-commentsend-fixed"
        style={{ background: alpha(componentColor, 1), bottom:isIphoneX() ? 22 : 0}}
      >
        <div className={`commentsend`}>
          <div
            className="comment-field"
            style={{
              background: alpha(h1Color, 0.05),
            }}
          >
            {/*replyId ? (
              <div className="reply" style={{ color: mainColor }}>
                {intl.get('Recomment')}
              </div>
            ) : null*/}
            <textarea
              key={0}
              id="commentInput0"
              ref={commentInput}
              placeholder={
                replyId
                  ? `${intl.get("Recomment")} @${replyName}：`
                  : intl.get("SaySomething")
              }
              style={{ color: h1Color }}
              value={commentText}
              onChange={(e: any) => {
                if (e && e.target) {
                  onChange(String(e.target.value));
                }
              }}
              onBlur={() => {
                if(pagedataStore.renderMode == 'pc') {
                  // @ts-ignore
                  focusTimer = setTimeout(() => {
                    onFocusChange(false);
                  }, 160);
                }
              }}
              maxLength={120}
            />
          </div>
          <div className="comment-extra">
            {question && !replyId ? (
              <div
                className={`question`}
                onClick={(e: any) => {
                  onQuestionChange(!isQuestion);
                  clearTimeout(focusTimer);
                  commentInput.current!.focus();
                }}
              >
                <div
                  className="circle"
                  style={{
                    borderColor: isQuestion ? mainColor : alpha(h1Color, 0.5),
                    background: isQuestion
                      ? alpha(mainColor, 0.3)
                      : `transparent`,
                  }}
                ></div>
                <span style={{ color: alpha(h1Color, 0.5) }}>
                  {intl.get("Question")}
                </span>
              </div>
            ) : null}

            <a
              className="comment-submit"
              onMouseDown={isWeb() ? commentSubmitEvent : undefined}
              onTouchStart={isWeb() ? undefined : commentSubmitEvent}
              style={
                posting
                  ? { background: bgColor, color: alpha(mainColor, 1) }
                  : { background: mainColor, color: alpha(bgColor, 1) }
              }
            >
              {posting ? intl.get("Sending") : intl.get("Send")}
            </a>
          </div>
        </div>

        {emotion && focus ? (
          <EmotionList onFetchEmotion={onFetchEmotion} list={emotionList} />
        ) : null}
      </div>
    </div>,
    wrapper! as HTMLElement
  );
};

const MobileCommentSend = (props: ICommentSend) => {
  const { gift, emotion, question, onSubmit, cid, renderMode} = props;
  const { wxuserStore, pagedataStore} = props.rootStore!;

  const [isQuestion, setIsQuestion] = useState(false);
  const [focus, setFocus] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [replyId, setReplyId] = useState(0);
  const [replyName, setReplyName] = useState("");
  const [commentText, setCommentText] = useState("");
  const { h1Color, mainColor, componentColor } = useContext(ThemeContext);
  const [componentContainer, setComponentContainer] = useState(
    {} as CSSProperties
  );
  const [paddingBottom, setPaddingBottom] = useState(0);

  const setFocusEvent = (bool: boolean) => {
    setFocus(bool);

    if (bool) {
      let event = new Event("custom-commentsend-focus");
      window.dispatchEvent(event);
    }
    if (!bool) {
      let event = new Event("custom-commentsend-blur");
      window.dispatchEvent(event);
    }
  };

  useEffect(() => {
    let component = getComponentById(window.pageDetail.template, props.cid);
    if (component && component.container) {
      setComponentContainer(setContainer(component, componentColor));
    }
    // console.log("comment send", component, props.cid);

    const { showNavigator } = useRealBottomTab();
    if (showNavigator) {
      setPaddingBottom(49);
    }
  }, []);

  const checkBlock = () => {
    if (isUserLogin()) {
      props.rootStore!.commentV2Store.checkblock();
    }
  };

  useEffect(() => {
    // checkBlock();
    const imMessageHandler = (e: any) => {
      if (e && e.openid && e.openid == wxuserStore.user.openid) {
        props.rootStore!.commentV2Store.setIsBlock(e.status);
      }
    };

    props.rootStore!.imStore.addMessageListener(
      "comment_block_change",
      imMessageHandler
    );

    return () => {
      props.rootStore!.imStore.removeMessageListener(
        "comment_block_change",
        imMessageHandler
      );
    };
  }, []);

  const showRecomment = (e: Event) => {
    let { data } = e;

    if (data) {
      setReplyId(data.id);
      setReplyName(data.nick_name);
      setCommentText("");
      setIsQuestion(data.type == "question");
      setFocusEvent(true);
    }
  };

  const showGift = () => {
    // 判断是否有登录
    if (wxuserStore.user.is_mock) {
      wxuserStore.auth();
      return;
    }

    if (window.configDetail && Number(window.configDetail.block_all) == 1) {
      // 全体禁言
      return;
    } else if (props.rootStore!.commentV2Store.isblock) {
      // 自己被禁言了
      return;
    }

    let event = new Event("custom-comment-gift-show");
    event.data = props.cid;
    window.dispatchEvent(event);
  };

  const postEmotion = (e: Event) => {
    let { data = {} } = e;

    let { id, name, image } = data;
    if (id) {
      onSubmit({
        type: "emotion",
        text: JSON.stringify({
          id,
          name,
          image,
        }),
        question: false,
        recomment: 0,
      }).then((res: any) => {
        setCommentText("");
        setFocusEvent(false);

        stat.event("comment_emotion", id);
      });
    }
  };

  const postGift = (e: Event) => {
    let { data = {} } = e;

    let { id, name, image, count } = data;
    if (id) {
      onSubmit({
        type: "gift",
        text: JSON.stringify({
          id,
          name,
          image,
          count,
        }),
        question: false,
        recomment: 0,
      }).then((res: any) => {
        setCommentText("");
        setFocusEvent(false);

        stat.event("comment_gift", id);
      });
    }
  };

  // 监听回复事件
  useEffect(() => {
    window.addEventListener("custom-comment-reply", showRecomment);
    return () => {
      window.removeEventListener("custom-comment-reply", showRecomment);
    };
  }, []);

  // 监听礼物发送事件
  useEffect(() => {
    window.addEventListener("custom-comment-gift-choose", postGift);
    window.addEventListener("custom-comment-emotion-choose", postEmotion);
    return () => {
      window.removeEventListener("custom-comment-gift-choose", postGift);
      window.removeEventListener("custom-comment-emotion-choose", postEmotion);
    };
  }, []);

  const isUserLogin = () => {
    if (wxuserStore && wxuserStore.user && !wxuserStore.user.is_mock) {
      return true;
    }
    return false;
  };

  const getCommentFieldPlaceholder = () => {
    if (isUserLogin()) {
      if (window.configDetail && Number(window.configDetail.block_all) == 1) {
        // 全体禁言
        return intl.get(`AllCommentForbid`);
      } else if (props.rootStore!.commentV2Store.isblock) {
        // 自己被禁言了
        return intl.get(`SelfCommentForbid`);
      } else {
        return intl.get(`SaySomething`);
      }
    } else {
      return intl.get(`ClickAndLogin`);
    }
  };

  const renderMethod = pagedataStore.renderMode == 'pc' && renderMode == 'pc' ? (child:any)=>{
    return child;
  } : (child:any, domContainer:HTMLElement)=>{
    return domContainer ? createPortal(child, domContainer) : null;
  };

  const pageContext = useContext(PageContext);
  const wrapperRef = usePortalDom({
    parentElement:window.document.getElementById(`page-bottom-${pageContext.cid}`)! as HTMLDivElement
  });

  return renderMethod(
    <div
      className="all-for-commentsend mobile"
      style={{
        ...componentContainer,
        backgroundColor: alpha(componentColor, 1),
        opacity: focus ? 1 : 1,
      }}
    >
      <div className={`commentsend`} style={{ background: componentColor }}>
        {/*emotion ? (
          <EmotionList
            onFetchEmotion={props.onFetchEmotion}
            list={props.rootStore!.commentV2Store.emotionList}
          />
        ) : null*/}
        <div
          className="comment-field"
          style={{ background: alpha(h1Color, 0.05) }}
        >
          <textarea
            placeholder={getCommentFieldPlaceholder()}
            readOnly={true}
            value={commentText}
            style={{ color: h1Color }}
            onClick={() => {
              // 判断是否有登录
              if (wxuserStore.user.is_mock) {
                wxuserStore.auth();
                return;
              }

              if (
                window.configDetail &&
                Number(window.configDetail.block_all) == 1
              ) {
                // 全体禁言
                return;
              } else if (props.rootStore!.commentV2Store.isblock) {
                // 自己被禁言了
                return;
              }

              setFocusEvent(true);
              setReplyId(0);
              setReplyName("");
              let targetDom = document.body.querySelector(
                "#mainTab>.react-swipeable-view-container>div[aria-hidden=false]"
              );
              if (targetDom) {
                setLastScrollTop(targetDom.scrollTop);
              }
            }}
          />
          <style>{`.comment-field>input::-webkit-input-placeholder {color:${alpha(
            h1Color,
            0.4
          )}}`}</style>
          {question ? (
            <div
              className={`question`}
              onClick={(e: any) => {
                setIsQuestion(!isQuestion);
              }}
            >
              <div
                className="circle"
                style={{
                  borderColor: isQuestion ? mainColor : alpha(h1Color, 0.5),
                  background: isQuestion
                    ? alpha(mainColor, 0.3)
                    : `transparent`,
                }}
              ></div>
              <span style={{ color: alpha(h1Color, 0.5) }}>
                {intl.get("Question")}
              </span>
            </div>
          ) : null}
        </div>
        {gift ? (
          <React.Fragment>
            <div
              className="gift"
              style={{
                background: componentColor,
                boxShadow: `0 0 4px 4px ${alpha(h1Color, 0.05)}`,
              }}
              onClick={showGift}
            >
              <i className="icon-gift" />
            </div>
            <GiftModal
              onFetchGift={props.onFetchGift}
              list={props.rootStore!.commentV2Store.giftList}
            />
          </React.Fragment>
        ) : null}
      </div>
      <FixedCommentSend
        focus={focus}
        replyId={replyId}
        replyName={replyName}
        question={question}
        isQuestion={isQuestion}
        commentText={commentText}
        onFetchEmotion={props.onFetchEmotion}
        emotion={emotion}
        emotionList={props.rootStore!.commentV2Store.emotionList}
        onQuestionChange={(e: boolean) => {
          setIsQuestion(e);
        }}
        onChange={(e: string) => {
          setCommentText(e);
        }}
        onSubmit={() => {
          return onSubmit({
            type: "text",
            text: commentText,
            question: isQuestion,
            recomment: replyId || 0,
          }).then((res: any) => {
            setCommentText("");
            setFocusEvent(false);
            setIsQuestion(false);
          });
        }}
        onFocusChange={(e: boolean) => {
          setFocusEvent(e);
        }}
        rootStore={props.rootStore}
      />
    </div>,
    wrapperRef! as HTMLElement
  );
};

export default inject("rootStore")(observer(MobileCommentSend));
